import Joi from "joi";

export const SALARY_DETAILS_SCHEMA = Joi.object({
  salary_type: Joi.string()
    .valid("fixed", "wages")
    .required()
    .messages({
      "any.required": "Salary Type is required",
      "any.only": "Invalid Salary Type",
    }),
    payment_mode: Joi.string()
    .valid("one-time", "monthly")
    .when("salary_type", {
      is: "fixed",
      then: Joi.required().messages({
        "any.required": "payment mode Mode is required for Wages Salary Type",
      }),
      otherwise: Joi.when('salary_type', {
        is: 'wages',
        then: Joi.allow(''),
        otherwise: Joi.optional(),
      }),
    }),
    ammount: Joi.number()
    .positive()
    .when("salary_type", {
      is: Joi.valid("fixed", "wages"),
      then: Joi.required().messages({
        "any.required": "Amount is required",
      }),
    }),

  payment_by: Joi.string()
    .valid("account_transfer", "cheque", "cash")
    .when("salary_type", {
      is: Joi.valid("fixed", "wages"),
      then: Joi.required().messages({
        "any.required": "Payment By is required",
      }),
    }),

    wages_type: Joi.alternatives()
    .conditional("salary_type", {
      is: "wages",
      then: Joi.string()
        .valid("days", "hours", "per")
        .required()
        .messages({
          "any.required": "Wage Type Mode is required for Wages Salary Type",
        }),
      otherwise: Joi.optional(),
    }),
  
    wages_rate: Joi.alternatives()
    .conditional("salary_type", {
      is: "wages",
      then: Joi.alternatives()
        .try(
          Joi.string().pattern(/^[1-9]\d*$/),
          Joi.number().positive()
        )
        .required()
        .messages({
          "any.required": "Wage Rate is required for Wages Salary Type",
          "number.base": "Wage Rate must be a number",
          "number.positive": "Wage Rate must be a positive number",
          "string.pattern.base": "Wage Rate must be a valid positive number (string)",
        }),
      otherwise: Joi.allow(null, '').messages({
        "any.only": "Wage Rate can only be null or an empty string for non-Wages Salary Type",
      }),
    }),
  

    wages_payment_mode: Joi.alternatives()
    .conditional("salary_type", {
      is: "wages",
      then: Joi.string()
        .valid("weekly", "fortnight_pay", "monthly")
        .required()
        .messages({
          "any.required": "Wage Payment Mode is required for Wages Salary Type",
          "any.only": "Wage Payment Mode must be one of [weekly, fortnight_pay, monthly] for Wages Salary Type",
        }),
      otherwise: Joi.allow(null, '').messages({
        "any.only": "Wage Payment Mode can only be null or an empty string for non-Wages Salary Type",
      }),
    }),
  
  
    wages_days: Joi.when('salary_type', {
      is: 'wages',
      then: Joi.alternatives()
        .try(
          Joi.string().pattern(/^[1-9]\d*$/),  // String that matches the pattern
          Joi.number().positive()  // Positive number
        )
        .required()
        .messages({
          "any.required": "Wage Days is required for Wages Salary Type",
          "number.base": "Wage Days must be a number",
          "number.positive": "Wage Days must be a positive number",
          "string.pattern.base": "Wage Days must be a valid positive number (string)",
        }),
      otherwise: Joi.allow(null, '').messages({
        "any.only": "Wage Days can only be null or an empty string for non-Wages Salary Type",
      }),
    }),
    
  


  // Bank Details
  bank_name: Joi.string()
  .when('payment_by', {
    is: 'account_transfer',
    then: Joi.required().messages({
      "any.required": "Bank Name is required",
    }),
    otherwise: Joi.forbidden(),
  }),

branch_name: Joi.string()
  .when('payment_by', {
    is: 'account_transfer',
    then: Joi.required().messages({
      "any.required": "Branch Name is required",
    }),
    otherwise: Joi.forbidden(),
  }),

account_number: Joi.number()
  .integer()
  .positive()
  .when('payment_by', {
    is: 'account_transfer',
    then: Joi.required().messages({
      "number.base": "Account Number must be a number",
      "number.positive": "Account Number must be positive",
      "number.integer": "Account Number must be an integer",
      "any.required": "Account Number is required",
    }),
    otherwise: Joi.forbidden(),
  }),

ifsc_code: Joi.string()
  .regex(/^[A-Za-z]{4}\d{7}$/)
  .when('payment_by', {
    is: 'account_transfer',
    then: Joi.required().messages({
      "string.pattern.base": "Invalid IFSC Code",
      "any.required": "IFSC Code is required",
    }),
    otherwise: Joi.forbidden(), 
  }),


}).unknown(true);
